'use client';

import { pushToDataLayer } from 'components/helpers/Global/Analytics/DataLayer';

export interface VideoAnalyticsPayload {
  videoId: string;
  videoTitle: string;
  videoUrl?: string;
  videoPercent?: number;
  videoVisible?: boolean;
  videoCurrentTime?: number;
  videoDuration?: number;
  videoProvider?: string;
}

export const pushVideoStartEvent = (payload: VideoAnalyticsPayload): void => {
  pushToDataLayer({
    event: 'video_start',
    video_id: payload.videoId,
    video_title: payload.videoTitle,
    video_url: payload.videoUrl,
    video_percent: payload.videoPercent,
    video_visible: payload.videoVisible,
    video_current_time: payload.videoCurrentTime,
    video_duration: payload.videoDuration,
    video_provider: payload.videoProvider,
  });
};

export const pushVideoCompleteEvent = (payload: VideoAnalyticsPayload): void => {
  pushToDataLayer({
    event: 'video_complete',
    video_id: payload.videoId,
    video_title: payload.videoTitle,
    video_url: payload.videoUrl,
    video_percent: payload.videoPercent,
    video_visible: payload.videoVisible,
    video_current_time: payload.videoCurrentTime,
    video_duration: payload.videoDuration,
    video_provider: payload.videoProvider,
  });
};

export const pushVideoPauseEvent = (payload: VideoAnalyticsPayload): void => {
  pushToDataLayer({
    event: 'video_pause',
    video_id: payload.videoId,
    video_title: payload.videoTitle,
    video_url: payload.videoUrl,
    video_percent: payload.videoPercent,
    video_visible: payload.videoVisible,
    video_current_time: payload.videoCurrentTime,
    video_duration: payload.videoDuration,
    video_provider: payload.videoProvider,
  });
};

export const pushVideoErrorEvent = (payload: VideoAnalyticsPayload, errorMessage: string): void => {
  pushToDataLayer({
    event: 'video_error',
    video_id: payload.videoId,
    video_title: payload.videoTitle,
    video_url: payload.videoUrl,
    video_percent: payload.videoPercent,
    video_visible: payload.videoVisible,
    video_current_time: payload.videoCurrentTime,
    video_duration: payload.videoDuration,
    video_provider: payload.videoProvider,
    error_message: errorMessage,
  });
};

export const pushVideoBufferingEvent = (payload: VideoAnalyticsPayload): void => {
  pushToDataLayer({
    event: 'video_buffering',
    video_id: payload.videoId,
    video_title: payload.videoTitle,
    video_url: payload.videoUrl,
    video_percent: payload.videoPercent,
    video_visible: payload.videoVisible,
    video_current_time: payload.videoCurrentTime,
    video_duration: payload.videoDuration,
    video_provider: payload.videoProvider,
  });
};

export const pushVideoReplayEvent = (payload: VideoAnalyticsPayload): void => {
  pushToDataLayer({
    event: 'video_replay',
    video_id: payload.videoId,
    video_title: payload.videoTitle,
    video_url: payload.videoUrl,
    video_percent: payload.videoPercent,
    video_visible: payload.videoVisible,
    video_current_time: payload.videoCurrentTime,
    video_duration: payload.videoDuration,
    video_provider: payload.videoProvider,
  });
};
